export default __webpack_public_path__ + "static/icons/icon-tshirt-1e4e1c9e6443e4e99870fd7c7fda1e41.svg";